import React, { useState } from 'react'

function About(props) {

     // For light-dark mode
    //  const [style, setstyle] = useState({
    //     color: 'black',
    //     backgroundColor: 'white'
    // })
    let style = {
        color: props.mode === "dark"?"white":"rgb(0 33 59)",
        backgroundColor: props.mode === "dark"?"rgb(0 33 59)":"white"
    }

  return (
    <>
    <div className="container" style={style}>
    <h1 className='my-2'>About Us.</h1>
      <div className="accordion my-3" id="accordionExample" style={style}>
        <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style={style}>
            About the App.
            </button>
            </h2>
            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
            <div className="accordion-body" style={style}>
                <strong>TextEditor: </strong>It is a tool which allows the user to do different kind's of operation with the given text. The operations are like, lower-case, upper-case, remove extra space and more. 
            </div>
            </div>
        </div>
        <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" style={style}>
                Free of Cost!
            </button>
            </h2>
            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
            <div className="accordion-body" style={style}>
                <strong>Free TextEditor: </strong> This text editor app is free of cost, and very easy to use editor. This app comes with very premium look. Which enable both light and dark mode.
            </div>
            </div>
        </div>
        <div className="accordion-item">
            <h2 className="accordion-header" id="headingThree">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" style={style}>
                About the Developer.
            </button>
            </h2>
            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
            <div className="accordion-body" style={style}>
                This text editor is developed by Full-Stack developer <strong>Arghya Ghosh</strong>. 
            </div>
            </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default About
